/* istanbul ignore file */
import ReactDOM from "react-dom/client";

import "./index.css";
// eslint-disable-next-line
import AppWrapper from "./containers/App";
// Import reportWebVitals from "./reportWebVitals"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<AppWrapper />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
